import type { NavGroup, NavItem } from './types';

export function isVisible(item: NavItem): boolean {
  return item.visible !== false;
}

function flatten(items: NavItem[]): NavItem[] {
  return items.flatMap((item) => [item, ...flatten(item.children ?? [])]);
}

/**
 * The nav entry the active path belongs to.
 *
 * A nested route like `/players/abc-123` must keep "/players" highlighted, so
 * this matches on prefix rather than equality — and takes the longest match so
 * `/settings/members` selects that entry rather than its `/settings` parent.
 */
export function activeItemFor(navGroups: NavGroup[], pathname: string): NavItem | undefined {
  return navGroups
    .flatMap((group) => flatten(group.items))
    .filter((item) => pathname === item.key || pathname.startsWith(`${item.key}/`))
    .sort((a, b) => b.key.length - a.key.length)[0];
}
